export default __webpack_public_path__ + "static/media/lc-bg.fadbd2b0.webp";